import autoAnimate from "@formkit/auto-animate";

const AutoAnimateHook = {
  mounted() {
    autoAnimate(this.el, {
      // Animation duration in milliseconds (use default: 250)
      duration: 250,
      // Easing for motion (use default: 'ease-in-out')
      easing: "ease-in-out",
    });
  },
};

export default AutoAnimateHook;
